import { render, staticRenderFns } from "./MoMoProtocol.vue?vue&type=template&id=877f14f0&scoped=true"
import script from "./MoMoProtocol.vue?vue&type=script&lang=js"
export * from "./MoMoProtocol.vue?vue&type=script&lang=js"
import style0 from "./MoMoProtocol.vue?vue&type=style&index=0&id=877f14f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877f14f0",
  null
  
)

export default component.exports